export const ID_SAN_CRISTOBAL = 4;

// Igual que Sancor: no se encontraron condiciones propias de San Cristóbal
// forzadas/validadas en el backend — se pasa tipoPersona/tipoUso tal cual a
// la API. Solo se cubre la card gris para array vacío y error de API.
export const evaluadorSanCristobal = {
   usaCardGris: true,
   mensajeArrayVacio:
      'San Cristóbal no tiene cotizaciones disponibles para los datos ingresados.',
   mensajeErrorApi:
      'San Cristóbal no tiene cotizaciones disponibles para el vehículo o los datos ingresados. Probá con otra cobertura o consultá con tu asesor comercial.',
};
